import React from 'react'
import { Helmet } from 'react-helmet'
import AdhanFeature from '../components/AdhanFeature'
import AdhanDeveloper from '../components/AdhanDeveloper'
import AdhanHero from '../components/AdhanHero'
import AdhanDownload from '../components/AdhanDownload'



export default function AdhanHome() {
  return (
    <>
    <Helmet>
      <title>Adhan : Prayer Tracking App</title>
    </Helmet>
    
    <AdhanHero />

    <AdhanFeature />
    
    <AdhanDownload />
    
    <AdhanDeveloper />
    </>
  )
}
